import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const dataLabelsPropTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  modifiedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  modifiedBy: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
